import React from "react";
import { useHistory } from "react-router-dom";
import NotFoundImg from "../assets/img/not-found.png";
import FullButton from "../components/Buttons/FullButton";
import styled from "styled-components";

const NotFound = () => {
  const history = useHistory();

  const handleGoHome = () => {
    history.push("/"); // Redirects to the homepage
  };

  return (
    <>
      <Wrapper>
        <ImgTag src={NotFoundImg} alt="404 Not Found" />
        <BtnDiv>
          <FullButton title="Go Home" action={handleGoHome} />
        </BtnDiv>
      </Wrapper>
    </>
  );
};

const Wrapper = styled.div`
  text-align: center;
  margin-top: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 747px;
`;

const ImgTag = styled.img`
  width: 600px;
  height: 600px;
  @media (max-width: 550px) {
    width: 400px;
    height: 400px;
  }
`;

const BtnDiv = styled.div`
  width: 100px;
`;

export default NotFound;
